module.exports = __webpack_public_path__ + "static/media/recent-orders.ab1fde30.svg";